/*
 *  Copyright (c) 2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import styled from "styled-components";
import { theme } from "@nordcloud/gnui";

export const StyledRect = styled.div`
  width: 0.75rem;
  height: 0.75rem;
  border-radius: ${theme.radius.sm};
  margin-right: ${theme.spacing.spacing02};
`;
